import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import GlobalStyle from "@asset/styles/GlobalStyle";
import App from "./App";

const routerBasename = (() => {
  const configured = process.env.REACT_APP_ROUTER_BASENAME || "";
  if (!configured || configured === "/") {
    return undefined;
  }

  const normalized = configured.startsWith("/")
    ? configured
    : `/${configured}`;
  return normalized.replace(/\/+$/, "");
})();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <BrowserRouter basename={routerBasename}>
    <GlobalStyle />
    <App />
  </BrowserRouter>,
);
